export default __webpack_public_path__ + "static/sydney-c01564d5d4d76f8c66b6d205ae31cc49.png";